"use strict";

Shopify.theme.jsCustomContactForm = {
    init: function init($section) {
        Shopify.theme.jsCustomContactForm = $.extend(this, Shopify.theme.getSectionData($section)); // Selectors
        // Selectors
        let $contactForm = $section.find('.contact-form__form'); // Contact form checkbox validation
        let $form = $contactForm.find('form')
        let $loader = $section.find('.contact-form__animation')
        let inputs = $form.find($("[name]"))
        let data = $form.serialize()
        let $submit = $form.find('button.is-within-form')
        let $dropdown = $section.find('.contact-form__dropdown')
        
        if($dropdown.length){
        	this.setupDropDowns($dropdown)
        }
        setTimeout(function(){
        $section.find('form').removeAttr('novalidate');
        $section.find('form').removeAttr('onsubmit');
        }, 500)

        if(this.isSuccess || this.isError){
          setTimeout(function(){
            $([document.documentElement, document.body]).animate({
                scrollTop: $(".jsCustomContactForm").offset().top
            }, 300);
          },1000)

        }
        //Validation
        $form.validate({
            rules: {
                // simple rule, converted to {required:true}
                "contact[Name]": {
                },
                // compound rule
                email: {
                    required: true,
                    email: true
                }
            },
            errorClass: "input-error",
            //debug: true,
            errorElement: "span",
            invalidHandler: function(event, validator) {
             $section.find('form').on('submit',function(e){
             	e.preventDefault()
                return false;
             })
            },
            submitHandler: function(form) {
              $section.find('form')[0].submit()
            }
        })


    },
//     submitForm: function submitForm($section) {
//         let $form = $section.find('form')
//         let $formContent = $section.find('.contact-form--main')
//         let $loader = $section.find('.contact-form__animation')
//         let $success = $section.find('.contact-form__success')
//         let $error = $section.find('.contact-form__error')
//         let inputs = $form.find($("[name]"))
//         let data = $form.serialize()

//         $formContent.removeClass('is-active')
//         $loader.addClass('is-active').find('video')[0].play()

//         var action = $form.attr("action")
//         console.log(Shopify.theme.jsCustomContactForm.formToJSON(inputs))
//         $.ajax({
//             url: action,
//             method: 'POST',
//             aysnc: true,
//             beforeSend:function(x){
//               x.setRequestHeader('Content-Type',"application/json;charset=UTF-8");
//               x.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
//             },
//             data: Shopify.theme.jsCustomContactForm.formToJSON(inputs),
//             success: function success() {
//               setTimeout(function(){
//                 //$loader.removeClass('is-active')
//                 $success.addClass('is-active')
//                  },3000)
                
//             },
//             error: function error(XMLHttpRequest, textStatus) {
              
// //                 var response = eval('(' + XMLHttpRequest.responseText + ')');
// //                 response = response.description;
//               setTimeout(function(){
//                 $loader.removeClass('is-active')
//                 $success.removeClass('is-active')
//                 $formContent.addClass('is-active')
//                 $error.text('Could not connect,Try again later!').addClass('is-active')

//               },3000)

//             }
//         });

//     },
//     formToJSON: function formToJSON(elements) {
//         return [].reduce.call(elements, function(data, element) {
//             data[element.name] = element.value;
//             return data;
//         }, {});
//     },
//     getUrlString: function getUrlString(data) {
//         var urlParameters = Object.entries(data).map(function(e) {
//             return e.join('=');
//         }).join('&');

//         return urlParameters;
//     },
    setupDropDowns: function setupDropDowns($dropdown){
      let $radio = $dropdown.find('input')
      let $list  = $dropdown.find('.contact-form__list')
      let $selected = $dropdown.find('[data-selected]')
      
      
      //CHECK IF THERE IS ANY PRESELECTED VALUE IN QUERY PARAMS
      let defaultSelection = Shopify.theme.params('selection')
      if(defaultSelection){
        defaultSelection = defaultSelection.trim()
        let $selectedItem =  $(`[data-selection-value="${defaultSelection}"]`) 
        setTimeout(function(){
          $selectedItem.trigger('change')
          $selectedItem.parents('.jsCustomContactForm').find('form')[0]?.scrollIntoView()
        },0)
      }
        $selected.on('click',function(){
          let $parent = $(this).parents('.contact-form__dropdown')
          
          if($parent.hasClass('dropdown-open')){
           $dropdown.removeClass('dropdown-open')
          }else{
           $dropdown.removeClass('dropdown-open')
           $(this).parents('.contact-form__dropdown').addClass('dropdown-open')
          }
         
          
        })
        $('body').not('.contact-form__block--radio').click(function(e) {
          if(!$(e.target).hasClass('contact-form__dropdown-selected')){
            $dropdown.removeClass('dropdown-open')
          }
        });
                
        $radio.change(function() {
          var dropdown = $(this).closest('.contact-form__dropdown');
          var radioname = $(this).attr('name');
          var checked = $(this)

          //update the text
          var checkedtext = $(checked).siblings('label').text();
          dropdown.find('[data-selected]').text( checkedtext );

          //retrieve the checked value, if needed in page 
          var thisvalue = dropdown.find( checked ).val();
          dropdown.removeClass('dropdown-open')

        });
    },
    unload: function unload() {
        var $contactForm = $('.contact-form__form');
        var $submitButton = $contactForm.find(':submit');
        $submitButton.off();
    }
};